import { type FC, useContext, useEffect } from 'react';

import { PageLoadingContext } from '@/components/__app/PageLoadingProvider.tsx';

const PageLoading: FC = () => {
  const context = useContext(PageLoadingContext);
  useEffect(() => {
    context.startLoading();
    return () => context.stopLoading();
  }, [context]);

  return null;
};

export default PageLoading;
